<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div class="m3">
        <div v-if="!store.getters.contacts.length" class="p3 white-bg flex my3">
          <span class="flex flex-auto h5n semi-bold justify-center">{{ getReferencelabel('NO_TRAVELLERS') }}</span>
        </div>
        <div v-for="(contact, index) in store.getters.contacts" v-else :key="index" class="py1 white-bg my3">
          <div class="col-12 flex flex-wrap py1">
            <div class="col-12 flex flex-column items-center">
              <span class="blue h3n bold center">{{ contact.firstname }} {{ contact.lastname }}</span>
              <p class="h3n semi-bold center blue m0">{{ genderVocabulary(contact.gender) }} {{ contact.birth_date }}</p>
            </div>
            <div class="col-12 flex justify-center">
              <Button reference="EDIT" class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="blue" :action="editContact.bind(this, contact.uuid)" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Button from '@/components/elements/Button';
import { genderVocabulary, getReferencelabel, routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: { Button },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    function editContact (uuid) {
      router.push({ name: 'EditContact', params: { uuid } });
    }

    return { route, store, editContact, genderVocabulary, getReferencelabel, routeMatchesComponent };
  }
};
</script>

<style>

</style>
